export default "__VITE_ASSET__Dd1wghe8__"